import { BusinessType, PaymentMethod } from './types';

export const BUSINESS_TYPES: { value: BusinessType; label: string }[] = [
  { value: 'General', label: '일반 기업' },
  { value: 'Agency', label: '이벤트∙광고대행사' },
  { value: 'School', label: '초∙중∙고등학교' },
  { value: 'University', label: '대학교∙대학원' },
  { value: 'Government', label: '공공기관∙지자체∙비영리단체' },
  { value: 'Museum', label: '도서관∙과학관∙박물관' }
];

export const CALL_TIME_OPTIONS = [
  { value: '08:00-10:00', label: '08:00-10:00' },
  { value: '10:00-12:00', label: '10:00-12:00' },
  { value: '14:00-16:00', label: '14:00-16:00' },
  { value: '16:00-18:00', label: '16:00-18:00' }
] as const;

export const PAYMENT_METHODS: { value: PaymentMethod; label: string }[] = [
  { value: 'Card', label: '카드 결제' },
  { value: 'Transfer', label: '계좌이체' }
];
